var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.styles.root},[_c('TheText',{class:_vm.styles.title,attrs:{"name":"caption","color":"foreground400"}},[_vm._v("Оплатите в течение "+_vm._s(_vm.timeLeft))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }